module.exports = __webpack_public_path__ + "static/newsletter-nov-dec-2019-071f94672a5cb542e2f92230cdf6fb4c.pdf";